export default __webpack_public_path__ + "static/media/ReceiptPopup.a7bc05e3.png";